import { styled } from "@mui/material";
const ToggleContainer = styled("div")(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  backgroundColor: theme.palette.common.white,
  color: theme.palette.grey[800],
  borderRadius: "4px 4px 0px 0px"
}));
export {
  ToggleContainer
};
